import { numericUtils } from './numeric.utils';

export const loanUtils = { calculateAllocationPct };

function calculateAllocationPct(allocation: number, order: number): number {
    return numericUtils.round(allocation / order * 100, 2);
}
